module.exports = __webpack_public_path__ + "pattern.2e457619a66204ab5616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pattern.jpg
// module id = 1379
// module chunks = 2